/** usage: from other page push to here
 *  this.$router.push({ name: 'name', params: { returnUrl: '/xxx/...'}});
 *  this.$router.push({ name: 'name', params: { msg: ''}});
 *  this.$router.push({ name: 'name', params: { returnUrl: process.env.PRE_PAGE_CODE, msg: ''}});
 *  notice: default will push to main page, returnName > returnUrl
 */
export default {
	name: 'gt-warn',
	mixins: [],
	extends: {},
	components: {},
	props: ['returnUrl', 'returnName', 'msg', 'title'],
	data() {
		return {
		};
	},
	computed: {},
	watch: {},
	created() {
	},
	mounted() {
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		goPage() {
			if (this.returnName) {
				this.$router.push({ name: this.returnName });
			} else if (this.returnUrl && (this.returnUrl === process.env.PRE_PAGE_CODE)) {
				this.$router.go(-1);
			} else if (this.returnUrl) {
				this.$router.push(this.returnUrl);
			} else {
				// this.$router.push(process.env.MAIN_PAGE);
				window.location.replace(process.env.MAIN_PAGE);
			}
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/service/warn/gt-warn.js